var map = {
	"./DSC_0006.jpg": "c205",
	"./DSC_0043_inPixio.jpg": "2914",
	"./DSC_0059-2.jpg": "f007",
	"./DSC_0074-2.jpg": "b5a3",
	"./Home_Bild1.jpg": "be54",
	"./Home_Bild2.jpg": "befc",
	"./Home_Bild3.jpg": "0bba",
	"./Home_Bild4.jpg": "bcf3",
	"./IMG_5g.jpg": "4e8c",
	"./IMG_6g.jpg": "1152",
	"./IMG_8g.jpg": "09d6",
	"./Spinnmaschinen.jpg": "bc6d",
	"./aussen1.jpg": "e368",
	"./aussen2.jpg": "7ed7",
	"./aussen3.jpg": "a19c",
	"./entrepreneur-1340649_1920.jpg": "54ed",
	"./fluessig.jpg": "b529",
	"./future.jpg": "accb",
	"./innen1.jpg": "06cb",
	"./iso_50001.jpg": "e7e4",
	"./iso_9001.jpg": "fa57",
	"./job-3338100_1920.jpg": "08b4",
	"./job-3338103_1920.jpg": "6bd5",
	"./letter.jpg": "9f50",
	"./pr1.jpg": "1ac8",
	"./pr2.jpg": "2cf2",
	"./pr3.jpg": "7582",
	"./pr4.jpg": "93f7",
	"./pro1.jpg": "b7f9",
	"./quali1.jpg": "97d3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "416a";